export default
[
    {
        "name": "Triangle count reduction",
        "enforce": [],
        "operations":
        [
            {
                "name": "Decimate to quality",
                "id": "decimate to quality",
                "params": 
                [
                    {
                        "name": "Level",
                        "id": "level",
                        "type": "dropdown",
                        "options": ["low", "medium", "high"],
                        "default": "medium"
                    }
                ]
            }
        ]
    }
];
